import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";
import { useScrollDepth } from "@/hooks/use-scroll-depth";

/**
 * SPA route tracker:
 *  - sends GA4 `page_view` on every client-side navigation
 *  - powers `scroll_depth` events
 *
 * Mounted once inside <BrowserRouter>.
 */
const RouteTracker = () => {
  const { pathname, search } = useLocation();

  useScrollDepth();

  useEffect(() => {
    trackEvent("page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
};

export default RouteTracker;
